import React from "react";
import { styled } from "@mui/material/styles";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import Switch from "@mui/material/Switch";
const Android12Switch = styled(Switch)(({ theme }) => ({
  padding: 8,
  "& .MuiSwitch-track": {
    borderRadius: 22 / 2,
    "&::before, &::after": {
      content: '""',
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      width: 16,
      height: 16,
    },
    "&::before": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M21,7L9,19L3.5,13.5L4.91,12.09L9,16.17L19.59,5.59L21,7Z"/></svg>')`,
      left: 12,
    },
    "&::after": {
      backgroundImage: `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="16" width="16" viewBox="0 0 24 24"><path fill="${encodeURIComponent(
        theme.palette.getContrastText(theme.palette.primary.main)
      )}" d="M19,13H5V11H19V13Z" /></svg>')`,
      right: 12,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    width: 16,
    height: 16,
    margin: 2,
  },
}));

const RestaurantDetails = () => {
  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.65rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };
  return (
    <>
      <div className="main_info_container">
        <div className="info_rs_header">
          <span className="Info_rs_header">Persontal Info.</span>
          <span className="Info-rs_reco">
            <span className="swich_title">IS RECOMMENDED</span>
            <Android12Switch />
          </span>
        </div>
        <div className="info_input_container">
          <div className="info_contain_input">
            <div className="input_box_container">
              <InputLabel sx={input_lable_style} htmlFor="custom-input">
                Restaurant Name
              </InputLabel>
              <TextField
                id="custom-input"
                placeholder="Enter Name"
                variant="outlined"
                autocomplete="off"
                size="small"
                className="input_container"
              />
            </div>
            <div className="input_box_container">
              <InputLabel sx={input_lable_style} htmlFor="custom-input">
                Restaurant Email
              </InputLabel>
              <TextField
                id="custom-input"
                placeholder="Enter Email"
                variant="outlined"
                autocomplete="off"
                size="small"
                className="input_container"
              />
            </div>
            <div className="input_box_container">
              <InputLabel sx={input_lable_style} htmlFor="custom-input">
                Restaurant Number
              </InputLabel>
              <TextField
                id="custom-input"
                placeholder="Enter Number"
                variant="outlined"
                autocomplete="off"
                size="small"
                className="input_container"
              />
            </div>
            <div className="input_box_container">
              <InputLabel sx={input_lable_style} htmlFor="custom-input">
                Restaurant License
              </InputLabel>
              <TextField
                id="custom-input"
                placeholder="Enter License"
                variant="outlined"
                autocomplete="off"
                size="small"
                className="input_container"
              />
            </div>
            <div className="input_box_container">
              <InputLabel sx={input_lable_style} htmlFor="custom-input">
                Restaurant Address <sup className="star_colour">*</sup>
              </InputLabel>
              <TextField
                id="custom-multiline-input"
                multiline
                rows={4}
                placeholder="Enter Address"
                variant="outlined"
                autocomplete="off"
                size="small"
                className="input_container"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="main_info_container">
        <div className="info_rs_header">
          <span className="Info_rs_header">Delivery Area</span>
          <span className="Info-rs_reco"></span>
        </div>
        <span className="info_phera">
          Enter a Redious from Store's central location in which you want to
          delivery
        </span>
        <div className="radious_main_container">
          <div className="radios_top_box">
            <div className="radios_top_box_le">
              <span className="Info_rs_header">Enter Delivery Radious(KM)</span>
              <TextField
                id="custom-input"
                placeholder="Enter Email"
                variant="outlined"
                autocomplete="off"
                size="small"
                className="radious_input"
              />
            </div>
            <div className="radios_top_box_rg">
              <div className="map_view_btn">View On Map</div>
            </div>
          </div>
          <div className="radios_bottom_box">
            <span className="info_phera_note">
              Note : Your store will serve within the radiour you enter
            </span>
          </div>
        </div>
      </div>
      <div className="map_view_btn">SAVE</div>
    </>
  );
};

export default RestaurantDetails;
